import { COLLEGE_YEAR_LEVELS, PROFESSIONAL_YEAR_LEVELS } from './profileOptions';

// Broad grouping used by the "Senior High School / ALS / College /
// Special Course" filter shown across the admin pages (Application
// Review, Reports, Scholar Management, User Management, Payroll).
// Mirrors server/src/lib/yearLevelCategory.ts.
const SENIOR_HIGH_YEAR_LEVELS = ['Grade 11', 'Grade 12'];
const ALS_YEAR_LEVELS = ['Alternative Learning System'];

export type YearLevelCategory = '' | 'senior_high' | 'college' | 'special_course' | 'als';

export const YEAR_LEVEL_CATEGORY_OPTIONS: { value: YearLevelCategory; label: string }[] = [
  { value: '', label: 'All Categories' },
  { value: 'senior_high', label: 'Senior High School' },
  { value: 'college', label: 'College' },
  { value: 'special_course', label: 'Special Course' },
  { value: 'als', label: 'ALS' }
];

export function yearLevelCategoryOf(yearLevel?: string): YearLevelCategory {
  if (!yearLevel) return '';
  if (SENIOR_HIGH_YEAR_LEVELS.includes(yearLevel)) return 'senior_high';
  if (COLLEGE_YEAR_LEVELS.includes(yearLevel)) return 'college';
  if (PROFESSIONAL_YEAR_LEVELS.includes(yearLevel)) return 'special_course';
  if (ALS_YEAR_LEVELS.includes(yearLevel)) return 'als';
  return '';
}
